<template>
  <b-form-select :id="safeId()" v-model="localValue" :options="options"
                 text-field="label" value-field="templateId">
  </b-form-select>
</template>

<script>
  export default {
    name: 'template-select',
    props: ['value'],
    data () {
      return {
        localValue: this.value
      }
    },
    computed: {
      options () {
        return this.$store.getters.templates().map(each => {
          return {
            templateId: each.templateId,
            label: each.name || each.templateId
          }
        })
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/template-select.vue